import { useState } from "react";

import { useEditSettingsMutation } from "@evr/apis/orgSettings";
import { PlanKeys } from "@evr/constant";
import { useAppSelector } from "@evr/hooks/reduxHooks";
import { selectUserOrgSettings, selectUserSubscription } from "@evr/store/slices/auth";
import { Button } from "@evr/ui/Button";
import { CircleLoading } from "@evr/ui/CircleLoading";
import { Flex, RowContainer, Wrapper } from "@evr/ui/FlexBox";
import { Input } from "@evr/ui/TextInput/styles";
import { Typography } from "@evr/ui/Typography";

export const SettingDefaultTemperature = () => {
  const { planType } = useAppSelector(selectUserSubscription);
  const orgSettings = useAppSelector(selectUserOrgSettings);
  const [temp, setDefaultTemperature] = useState(orgSettings.defaultTemperature?.toString() ?? "");
  const [editDefaultTemperature, { isLoading }] = useEditSettingsMutation();
  const MAX_TEMP = 60;
  const MIN_TEMP = -60;
  const isFreePlan = planType === PlanKeys.STARTER;
  const isToggleOff = !orgSettings.defaultWeatherToggle;

  const handleSetDefaultTemperature = () => {
    const numericTemp = Number(temp);
  
    if (isNaN(numericTemp)) {return;};
  
    if (numericTemp > MAX_TEMP) {
        setDefaultTemperature(String(MAX_TEMP)); 
    }

    if (numericTemp < MIN_TEMP) {
        setDefaultTemperature(String(MIN_TEMP)); 
    }
  
    editDefaultTemperature({ ...orgSettings, defaultTemperature: numericTemp });
  };

  return (
    <RowContainer width="100%" justify="flex-start">
      <Typography>Default Temperature</Typography>
      <Flex margin="0.2rem 0.2rem 0.2rem auto" title={isFreePlan ? "This item is not active on your plan" : ""}>
        <Input
          type="number"
          width="80px"
          padding="0.35rem 0.4rem"
          disabled={isFreePlan || isToggleOff}
          value={temp}
          min={-50}
          max={50}
          onChange={(e) => setDefaultTemperature(e.target.value)}
          />
        <Wrapper position="relative">
          {isLoading && <CircleLoading size={4} />}
          <Button onClick={handleSetDefaultTemperature} disabled={isFreePlan || isLoading || isToggleOff}>
            Set
          </Button>
        </Wrapper>
      </Flex>
    </RowContainer>
  );
};
